/**
 * @desc 一键出库
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(dono: string | number, options?: any) {
  return updateResponse(
    http(URL + `/outMaster/onceOutStorage/${dono}`, {
      method: "POST",

      ...options,
    }),
  );
}
